module.exports = __webpack_public_path__ + "media/components/video_discovery/assets/Watch_Now-cdedcf582e2d53cec54b52c616e80b37.svg";